import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { ArrowRight, MailCheck, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-white px-6" data-testid="forgot-password-page">
      <div className="w-full max-w-sm">
        <img src="/stockly-logo-tight.png" alt="Stockly" className="w-40 h-auto mb-8" />
        <Link to="/login" className="inline-flex items-center gap-1 text-sm text-zinc-500 hover:text-[#1B2D5C] mb-6">
          <ArrowLeft size={14} /> Terug naar inloggen
        </Link>

        {!sent ? (
          <>
            <h1 className="text-3xl font-bold tracking-tight mb-2 text-[#1B2D5C]">Wachtwoord vergeten?</h1>
            <p className="text-sm text-zinc-500 mb-6">Vul je e-mailadres in. We sturen je een herstellink.</p>
            <form onSubmit={onSubmit} className="space-y-4" data-testid="forgot-form">
              <div>
                <label className="overline block mb-2">E-mail</label>
                <input
                  type="email" required value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full h-11 px-3 border border-zinc-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#5BC044]/45 focus:border-[#5BC044]"
                  data-testid="forgot-email-input"
                  placeholder="jij@bedrijf.nl"
                />
              </div>
              {err && <div className="text-sm text-red-600">{err}</div>}
              <button type="submit" disabled={loading}
                className="w-full h-11 bg-[#5BC044] hover:bg-[#4FAA3A] disabled:opacity-60 text-white rounded-md font-semibold inline-flex items-center justify-center gap-2"
                data-testid="forgot-submit-button"
              >
                {loading ? "Bezig…" : "Herstellink versturen"} <ArrowRight size={16} />
              </button>
            </form>
          </>
        ) : (
          <div className="text-center" data-testid="forgot-sent-state">
            <div className="w-16 h-16 mx-auto rounded-full bg-emerald-50 flex items-center justify-center mb-4">
              <MailCheck size={28} className="text-[#5BC044]" />
            </div>
            <h1 className="text-2xl font-bold tracking-tight mb-2 text-[#1B2D5C]">Check je inbox</h1>
            <p className="text-sm text-zinc-500 mb-6">
              Als <b>{email}</b> bekend is, ontvang je binnen enkele minuten een e-mail met een herstellink (geldig 1 uur).
            </p>
            <Link to="/login" className="inline-flex items-center gap-1 text-sm font-medium text-[#5BC044] hover:underline">
              Terug naar inloggen <ArrowRight size={14} />
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
